import React from "react";
import { Box, Typography } from "@mui/material";

export function OverviewHeaderBar({ title, actions, sx }) {
  return (
    <Box
      paddingLeft={3}
      paddingRight={3}
      paddingTop={3}
      sx={{
        minHeight: 56,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        // Use stretch then inner alignment to better vertically center varied control heights
        alignItems: { xs: "flex-start", md: "stretch" },
        justifyContent: "space-between",
        gap: 2,
        ...sx,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          mb: { xs: 1, md: 0 },
          display: "flex",
          alignItems: "center",
        }}
      >
        {title && (
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          // Ensure all interactive elements align vertically centered
          alignItems: "center",
          justifyContent: { xs: "flex-start", md: "flex-end" },
          gap: 2,
          width: { xs: "100%", md: "auto" },
          // Normalize heights for MUI contained buttons and textfields when mixed
          "& .MuiButton-root": { alignSelf: "center" },
          "& .MuiTextField-root": { alignSelf: "center", mt: 0 },
          // Prevent wrapping items from mis-aligning vertically when they wrap
          rowGap: 2,
        }}
      >
        {actions}
      </Box>
    </Box>
  );
}

export default OverviewHeaderBar;
